var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{staticClass:"portal",attrs:{"selector":"#topic-portal"}},[_c('div',{staticStyle:{"width":"100%"}},[_c('ConfirmationDialogProvider',[_c('TopicPage')],1),_c('Lightbox',{attrs:{"service":_vm.lightboxService}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }